module.exports = __webpack_public_path__ + "static/advert-mobile-ed3f8b2cc6f9be516994551658a3a979.jpg";